import styled from "@mui/styled-engine-sc";
import { Link } from "react-router-dom";
import { palette } from "../../themes/color-palette";

export const LinkWrapper = (props: any) => {
  const { testId, to = "", href = "", target = "_self", ...rest } = props;
  const { pathname } = to;
  let dataTestId;
  if (!testId) {
    dataTestId =
      pathname === "" || pathname
        ? { "data-testid": pathname.split("/").filter(Boolean).join("-") }
        : to
        ? { "data-testid": to.split("/").filter(Boolean).join("-") }
        : {};
  } else {
    dataTestId = { "data-testid": `${testId}-link` };
  }
  if (href) {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a {...{ ...rest, href }} target={target} />;
  } else {
    return <Link {...{ ...dataTestId, ...rest, to, href }} />;
  }
};

const StyledLink = styled(LinkWrapper)`
  ${({ theme }) => `
    color: ${theme.palette.black.main};
    text-decoration: none;

    svg {
      color: ${theme.palette.black.main};
    }

    &:hover {
      //color: ${theme.palette.black.dark};

      svg {
        color: ${theme.palette.black.dark};
      }
    }

    &.disabled {
        color: ${theme.palette.text.disabled};
    }

    &.underline {
      text-decoration: underline;
    }

    &.secondary {
      color: ${theme.palette.secondary.main};

      svg {
        color: ${theme.palette.secondary.main};
      }
    }

    &.store-selection-external-link {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 13px;
      font-weight: 400;
      color: ${palette.blue.dark};
    }

  `}
`;

export const StyledHeaderFooterLink = styled(({ ...props }) => <StyledLink {...props} />)`
  ${({ theme }) => `
    color: ${theme.palette.text.primary};

    &:hover {
      font-weight: 700;
    }
    &.primary {
      color: ${theme.palette.primary.main};
      font-weight: 700;
    }
    &.secondary {
      color: ${theme.palette.secondary.main};
      font-weight: 700;
    }

  `}
`;

export { StyledLink };
